import { Catalog } from '@one/types'
import { BrandsState } from './types'

export default {
  brandsLength: (state: BrandsState) => state.brandsTree.length,
  getBrandsTree: (state: BrandsState) => state.brandsTree,
  getHighlightedBrandsTree: (state: BrandsState) => state.highlightedBrandsTree,
  selectedBrandId: (state: BrandsState) =>
    state.selectedBrand?.brand?.id ?? null,
  selectedBrandName: (state: BrandsState) =>
    state.selectedBrand?.brand?.name ?? null,
  selectedBrand: (state: BrandsState) => state.selectedBrand,
  getBrandByName: (state: BrandsState) => (name: string) =>
    state.brandsTree.find(
      (item: Catalog.BrandAndSeriesTreeItem) => item.brand.name === name,
    ),
  getSeriesByName: (state: BrandsState) => (name: string) => {
    for (const item of state.brandsTree) {
      const series = item.series.find(s => s.name === name)
      if (series) {
        return {
          brand: item.brand,
          series,
        }
      }
    }
    return null
  },
}
